// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/tok/ttookk/jenkin_cache/tok_website_boss/node_modules/@umijs/max/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SmileOutlined };
